var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('div',{staticClass:"foot"},[_c('span',[_vm._v("©版权归Shuaib团队所有 如有需求请联系QQ: 2631667689")]),_c('span',[_vm._v("2022-6-19")])])])}
var staticRenderFns = []

export { render, staticRenderFns }